import { render } from "./CentralUnitsList.vue?vue&type=template&id=108c154a&scoped=true"
import script from "./CentralUnitsList.vue?vue&type=script&lang=js"
export * from "./CentralUnitsList.vue?vue&type=script&lang=js"

import "./CentralUnitsList.vue?vue&type=style&index=0&id=108c154a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108c154a"]])

export default __exports__